module.exports = __webpack_public_path__ + "img/pantalla-2-8.1d7a72af.png";